import React from 'react';
import TrademarkSearch from '../components/TrademarkSearch';

const SearchPage = () => {
  return <TrademarkSearch />;
};

export default SearchPage;
